import React from 'react';
import DetailsCard from './DetailsCard';
import useTicket from '../../../../../../hooks/api/useTicket';
import Ticket from '../../../../../../interfaces/api/Ticket';
import { useRecoilState } from 'recoil';
import { ticketState } from '../../../../../../recoil/selectors/tickets';

const DetailsCardContainer = ({ style, hidden, ...props }) => {
  const [ticket, setTicket] = useRecoilState(ticketState(props.ticket.id));
  const { update } = useTicket();

  const handleUpdateField = async <T extends keyof Ticket>(fieldName: T, newValue: Ticket[T]) => {
    if (ticket) {
      const newTicket = await update(ticket.id, { [fieldName]: newValue });
      setTicket(newTicket);
    }
  };

  if (!ticket) {
    return null;
  }

  return <DetailsCard ticket={ticket} onUpdateField={handleUpdateField} hidden={hidden} style={style} />;
};

export default React.memo(DetailsCardContainer);
